export const getAllUserReferrals = () => {
    return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v2/referrals/admin/referees`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`, // Uncomment if using auth
      },
    })
      .then(res => res.json())
      .catch(e => {
        console.log(`error at getting all referrals: ${e}`);
      });
  };
  


  export const getUsersRefferalDeatils = id => {
    return fetch(
      `${process.env.REACT_APP_DATABASEURL}/api/v2/referrals/admin/referees/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then(res => {
        return res.json();
      })
      .catch(e => console.log(`error at get coupons used users ${e}`));
  };
  